module.exports = __webpack_public_path__ + "f19f41689bc1f7a48a23c8e41607b6fb.pdf";